import React from 'react';
import styled from 'styled-components';
import { Image, Select } from 'antd';
import { theme } from 'utils/style/theme';
import { IImagePropsList } from 'utils/types/common';
const { Option } = Select;
/**
 * * 이미지 셀렉박스
 */

interface IProps {
  style?: React.CSSProperties;
  value?: string | number | undefined | null;
  defaultValue?: string | undefined | null;
  name?: string | undefined | null;
  title?: string | undefined | null;
  imgUrl?: string;
  optionList?: IImagePropsList[] | undefined;
  onChange?: (e: any, data: any) => void;
  placement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight';
  labelTitle?: string;
  left?: boolean;
  noMarginBottom?: boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
}
const ImageSelect = ({
  style,
  left,
  onChange,
  defaultValue,
  value,
  name,
  title,
  optionList,
  imgUrl,
  placement,
  labelTitle,
  noMarginBottom,
}: IProps) => {
  return (
    <Container
      left={left}
      labelTitle={labelTitle}
      style={style}
      noMarginBottom={noMarginBottom}
    >
      <label>{labelTitle}</label>
      <Select
        placeholder={'이미지를 \n선택해주세요.'}
        onChange={onChange}
        defaultValue={defaultValue}
        value={value}
        allowClear
        placement={placement}
      >
        {optionList?.map((v) => (
          <Option
            key={v.design_id}
            value={v.design_id}
            name={name}
            title={title}
          >
            {v.image_url ? (
              <Image
                src={v.image_url}
                // src={imgUrl !== '' || imgUrl !== null ? imgUrl : v.image_url}
                height={`8rem`}
                style={{ objectFit: 'contain' }}
              />
            ) : (
              <p>{v.text}</p>
            )}
          </Option>
        ))}
      </Select>
    </Container>
  );
};

export default ImageSelect;

const Container = styled.div`
  width: 100%;
  margin-right: ${(props) => (props.left ? '1.5rem' : 'unset')};
  margin-bottom: ${(props) => (props.noMarginBottom ? '0' : '1.2rem')};
  label {
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.3rem;
    margin-bottom: 0.2rem;
    display: ${(props) => (props.labelTitle ? 'block' : 'none')};
  }
  .ant-select {
    width: ${(props) => (props.selectWidth ? props.selectWidth : '100%')};
    /* height: 100%; */
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 8rem;
    width: inherit;
    border-radius: 0.4rem;
    border: 1px solid ${theme.colors.gray_5};
  }
  .ant-image-mask {
    height: 8rem;
  }
  .ant-image-mask-info {
    position: absolute;
    top: 0;
  }
  .ant-select-selection-placeholder {
    white-space: pre-wrap;
    line-height: 1rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;
